var KeyCodes;

(function (KeyCodes) {
  KeyCodes["tab"] = "9";
  KeyCodes["backspace"] = "8";
  KeyCodes["enter"] = "13";
  KeyCodes["escape"] = "27";
  KeyCodes["space"] = "32";
  KeyCodes["pageUp"] = "33";
  KeyCodes["pageDown"] = "34";
  KeyCodes["end"] = "35";
  KeyCodes["home"] = "36";
  KeyCodes["left"] = "37";
  KeyCodes["up"] = "38";
  KeyCodes["right"] = "39";
  KeyCodes["down"] = "40";
  KeyCodes["delete"] = "46";
  KeyCodes["comma"] = "188";
})(KeyCodes || (KeyCodes = {}));

export default KeyCodes;